export default __webpack_public_path__ + "static/media/image 150.3b24bcad.png";